import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';

import { Auth } from 'src/providers/auth/auth';
import { TidyStorage } from 'src/shared/providers/tidy-storage';

const standardFlowTypes = ['company', 'developer', 'normal', 'private', 'rental', 'maintenance', 'employee'];

@Injectable({
  providedIn: 'root'
})
export class PartnerSignupRedirectGuard implements CanActivate {

  private auth = inject(Auth);
  private storage = inject(TidyStorage);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const flowType = route.params['flowType'];
    const isCustomFlow = flowType && !standardFlowTypes.includes(flowType);

    if (!isCustomFlow) {
      return true;
    }

    if (this.auth.isAuthenticated()) {
      const themeMode = localStorage.getItem('tidy_theme_mode');
      const themeUserSet = localStorage.getItem('tidy_theme_user_set');
      localStorage.clear();
      await this.storage.clear();
      if (themeMode) { localStorage.setItem('tidy_theme_mode', themeMode); }
      if (themeUserSet) { localStorage.setItem('tidy_theme_user_set', themeUserSet); }
    }

    localStorage.setItem('pendingPartnerCode', flowType);
    window.location.href = '/#/overview';
    return false;
  }
}
